module.exports = __webpack_public_path__ + "static/media/search-vector.21418f48.svg";